import { Box, Button, InputBase, TextField, Typography } from "@mui/material";
import React from "react";

const SubscribeComponent = () => {
  return (
    <Box
      sx={{
        // mx: { xs: "16px", sm: "24px", md: "7%", xl: "150px" },
        mx: { xs: "16px", sm: "24px", md: "7%", xl: "auto" },
        mt: { xs: "1rem", sm: "1rem", md: "5rem", xl: "128px" },
        p: { xs: " 1rem", sm: "32px", md: "50px", xl: "77px 136px" },
        bgcolor: "#213F4B",
        borderRadius: { xs: "16px", sm: "20px", xl: "34px" },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "center", md: "start" },
        justifyContent: "space-between",
        gap: { xs: "24px", md: "0" },
        minHeight: { xs: "auto", md: "327px" },
        maxWidth: "1660px",
      }}
    >
      <Box
        sx={{
          flex: 1,
          borderRight: { xs: "none", md: "1px solid white" },
          borderBottom: { xs: "1px solid white", md: "none" },
          pr: { xs: "0", sm: "20px", md: "25px", xl: "50px" },
          pb: { xs: "24px", md: "0" },
          width: "100%",
          textAlign: { xs: "left", md: "left" },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: "white",
            fontSize: { xs: "20px", sm: "24px", md: "28px", xl: "36px" },
            fontWeight: 400,
            lineHeight: { xs: "28px", sm: "32px", md: "40px", xl: "57.42px" },
            fontFamily: "DM Serif Text",
          }}
        >
          Subscribe To Our News letter For The
        </Typography>
        <Typography
          variant="h2"
          sx={{
            color: "#E9C46A",
            fontSize: { xs: "20px", sm: "24px", md: "28px", xl: "36px" },
            fontWeight: 400,
            lineHeight: { xs: "28px", sm: "32px", md: "40px", xl: "57.42px" },
            fontFamily: "DM Serif Text",
            mt: { xs: "2px", md: "4px" },
          }}
        >
          Latest Jobs Updates.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "white",
            fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.9rem", xl: "1rem" },
            fontWeight: 400,
            lineHeight: { xs: "20px", sm: "24px", md: "26px", xl: "28.8px" },
            mt: { xs: "8px", sm: "10px", md: "11px" },
            maxWidth: { xs: "100%", md: "90%" },
          }}
        >
          Passages of lorem ipsum available, but the majority have suffered
          alteration, by injected words.
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          pl: { xs: "0", sm: "20px", md: "40px", xl: "101px" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: { xs: "center", md: "start" },
          width: "100%",
          gap: { xs: "16px", md: "24px" },
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            variant="h2"
            sx={{
              color: "white",
              fontSize: { xs: "18px", sm: "20px", md: "22px", xl: "24px" },
              fontWeight: 400,
              lineHeight: { xs: "24px", sm: "28px", md: "30px", xl: "32px" },
              textAlign: { xs: "left", md: "left" },
            }}
          >
            Subscribe for the latest jobs Updates.
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: "12px", sm: "8px" },
            alignItems: "center",
          }}
        >
          <InputBase
            placeholder="Email"
            variant="outlined"
            sx={{
              borderRadius: { xs: "8px !important", xl: "10px !important" },
              p: "8px 12px !important",
              bgcolor: "white !important",
              color: "black !important",
              height: "46px !important",
              width: { xs: "100% !important", sm: "296px !important" },
              maxWidth: { xs: "100% !important", sm: "296px !important" },
            }}
          />
          <Button
            variant="contained"
            className="subscribe_btn"
            sx={{
              bgcolor: "#E9C369 !important",
              color: "#213F4B !important",
              fontSize: {
                xs: "14px !important",
                // md: "15px !important",
                xl: "16px !important",
              },
              fontWeight: 600,
              height: "46px !important",
              borderRadius: { xs: "8px !important", xl: "10px !important" },
              p: { xs: "8px 16px !important", sm: "10px 24px !important" },
              width: { xs: "100% !important", sm: "auto !important" },
              "&:hover": {
                bgcolor: "#E9C369 !important",
              },
            }}
          >
            Subscribe now
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SubscribeComponent;
